<template>
    <div class="c-a-checkboxes" :class="{'c-a-checkboxes--invalid' : invalid}">
        <p class="c-a-checkboxes__title">{{label}}<span v-if="required"> *</span></p>
        <div class="c-a-checkboxes__inner">
            <div class="c-a-checkboxes__checkbox" v-for="option in alternatives" :key="option.id">
                <input class="c-a-checkboxes__input"
                    :key="`question-${id}-option-${option.id}`"
                    :id="`question-${id}-option-${option.id}`"
                    type="checkbox"
                    :value="option"
                    v-model="selectedValues"
                    @change="updated"
                />
                <label class="c-a-checkboxes__label" :for="`question-${id}-option-${option.id}`">
                    <span class="c-a-checkboxes__box"><icon :icon="'check'" /></span>
                    <transition name="c-a-checkboxes__textfield--animation" mode="out-in" v-on:after-enter="afterInputAnimationEnter">
                        <input
                            v-if="option.type == 'Annan' && containsSelected(option)"
                            v-model="other"
                            :ref="'inputField'"
                            @change="handleOtherUpdate"
                            class="c-a-checkboxes__textfield"
                            type="text"
                            :placeholder="option.text">
                        <span v-else class="c-a-checkboxes__text">{{option.text}}</span>
                    </transition>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    import Icon from '../AtomIcon.vue';

    export default {
        props: {
            id: Number,
            label: String,
            alternatives: Array,
            invalid: Boolean,
            required: Boolean,
            dataKey: String,
        },
        data(){
            return {
                selectedValues: [],
                savedOtherValues: '',
                other: '',
            };
        },
        components: {
            Icon
        },
        methods:{
            containsSelected(option) {
                const matches = this.selectedValues.filter( value => value === option)
                return matches.length > 0 ? true : false
            },
            updated(event){
                const data = {
                    questionId: this.id,
                    label: this.label,
                    answers: this.selectedValues,
                    multi: true
                };

                if(this.dataKey){
                    data.dataKey = this.dataKey;
                }

                this.$emit('updateData', data);
            },
            afterInputAnimationEnter: function (el) {
                if (el.tagName === 'INPUT') {
                    el.focus();
                }
            },
            handleOtherUpdate (evt) {
                const value = evt.target.value;
                this.selectedValues = this.selectedValues.map(val => {
                    if (val.type === 'Annan') {
                            val.text = value;
                    }
                    return val;
                });
                this.updated();
                this.savedOtherValues = value;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/atoms/request-form/AtomCheckboxesRequestForm.vue